<template>
  <nav>
    <ul>
      <li>
        <router-link to="/calculator">
          <span class="icon">
            <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.5917 5.2806V19.6556C18.5917 20.9781 17.5183 22.0514 16.1958 22.0514H6.61251C5.29001 22.0514 4.21667 20.9781 4.21667 19.6556V5.2806C4.21667 3.9581 5.29001 2.88477 6.61251 2.88477H16.1958C17.5183 2.88477 18.5917 3.9581 18.5917 5.2806ZM17.3957 5.2806C17.3957 4.62127 16.859 4.0846 16.1997 4.0846H6.61251C5.95317 4.0846 5.41651 4.62127 5.41651 5.2806V7.67643H17.3957V5.2806ZM17.3957 8.87627H5.41267V19.6556C5.41267 20.3149 5.94934 20.8516 6.60867 20.8516H16.1958C16.8552 20.8516 17.3918 20.3149 17.3918 19.6556V8.87243L17.3957 8.87627ZM6.61251 18.4558C6.61251 18.1261 6.88084 17.8578 7.21051 17.8578H12.0022C12.3318 17.8578 12.6002 18.1261 12.6002 18.4558C12.6002 18.7854 12.3318 19.0538 12.0022 19.0538H7.21051C6.88084 19.0538 6.61251 18.7854 6.61251 18.4558ZM6.91151 11.2683C6.91151 10.7699 7.31017 10.3713 7.80851 10.3713C8.30684 10.3713 8.70551 10.7738 8.70551 11.2683C8.70551 11.7628 8.30301 12.1653 7.80851 12.1653C7.31401 12.1653 6.91151 11.7666 6.91151 11.2683ZM6.91151 14.8639C6.91151 14.3656 7.31017 13.9669 7.80851 13.9669C8.30684 13.9669 8.70551 14.3694 8.70551 14.8639C8.70551 15.3584 8.30301 15.7609 7.80851 15.7609C7.31401 15.7609 6.91151 15.3623 6.91151 14.8639ZM10.5072 11.2683C10.5072 10.7699 10.9058 10.3713 11.4042 10.3713C11.9025 10.3713 12.3012 10.7738 12.3012 11.2683C12.3012 11.7628 11.8987 12.1653 11.4042 12.1653C10.9097 12.1653 10.5072 11.7666 10.5072 11.2683ZM10.5072 14.8639C10.5072 14.3656 10.9058 13.9669 11.4042 13.9669C11.9025 13.9669 12.3012 14.3694 12.3012 14.8639C12.3012 15.3584 11.8987 15.7609 11.4042 15.7609C10.9097 15.7609 10.5072 15.3623 10.5072 14.8639ZM14.1028 11.2683C14.1028 10.7699 14.5015 10.3713 14.9998 10.3713C15.4982 10.3713 15.8968 10.7738 15.8968 11.2683C15.8968 11.7628 15.4943 12.1653 14.9998 12.1653C14.5053 12.1653 14.1028 11.7666 14.1028 11.2683ZM14.1028 14.8639C14.1028 14.3656 14.5015 13.9669 14.9998 13.9669C15.4982 13.9669 15.8968 14.3694 15.8968 14.8639C15.8968 15.3584 15.4943 15.7609 14.9998 15.7609C14.5053 15.7609 14.1028 15.3623 14.1028 14.8639ZM14.1028 18.4596C14.1028 17.9651 14.5053 17.5626 14.9998 17.5626C15.4943 17.5626 15.8968 17.9651 15.8968 18.4596C15.8968 18.9541 15.4943 19.3566 14.9998 19.3566C14.5053 19.3566 14.1028 18.9541 14.1028 18.4596Z" fill="white"/>
            </svg>
          </span>
          <span class="title">
            Calculator
          </span>
          <span class="arrow">
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.4375 13.2617C1.17383 13.2617 0.939453 13.1738 0.763672 12.998C0.382812 12.6465 0.382812 12.0312 0.763672 11.6797L5.71484 6.69922L0.763672 1.74805C0.382812 1.39648 0.382812 0.78125 0.763672 0.429688C1.11523 0.0488281 1.73047 0.0488281 2.08203 0.429688L7.70703 6.05469C8.08789 6.40625 8.08789 7.02148 7.70703 7.37305L2.08203 12.998C1.90625 13.1738 1.67188 13.2617 1.4375 13.2617Z" fill="currentColor"/>
            </svg>
          </span>
        </router-link>
      </li>
      <li>
        <a href="tel://1300367589">
          <span class="icon">
            <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.6578 17.0116L19.8758 20.408C19.7033 21.1516 19.0517 21.6691 18.2888 21.6691C9.47215 21.6691 2.29999 14.497 2.29999 5.68029C2.29999 4.91746 2.82132 4.2658 3.56499 4.09713L6.95749 3.31129C7.72032 3.13496 8.50615 3.52979 8.82049 4.25429L10.3845 7.9113C10.672 8.58213 10.488 9.34496 9.92449 9.8088L8.46782 11.001C9.49899 12.8946 11.0783 14.474 12.972 15.5051L14.1642 14.0523C14.6165 13.4965 15.3947 13.3048 16.0617 13.5808L19.7187 15.1486C20.4393 15.463 20.838 16.245 20.6617 17.0116H20.6578ZM19.5347 16.7548C19.5845 16.5286 19.4695 16.2986 19.2587 16.2066L15.6093 14.6426C15.4177 14.5621 15.1838 14.6158 15.0535 14.7806L13.5662 16.5938C13.3975 16.8008 13.1062 16.866 12.8685 16.7471C10.4305 15.5473 8.42949 13.5463 7.22965 11.1083C7.11082 10.8668 7.17599 10.5793 7.37915 10.4106L9.19232 8.9233C9.35715 8.7853 9.41082 8.55913 9.32649 8.36363L7.76249 4.70663C7.68582 4.5303 7.50949 4.41913 7.32165 4.41913C7.28715 4.41913 7.24882 4.41913 7.21432 4.43063L3.82182 5.21646C3.60332 5.26629 3.44999 5.45796 3.44999 5.68029C3.44999 13.8645 10.1047 20.5191 18.2888 20.5191C18.5112 20.5191 18.7067 20.362 18.7565 20.1473L19.5385 16.751L19.5347 16.7548Z" fill="white"/>
            </svg>
          </span>
          <span class="title">
            Call 1300 367 589
          </span>
          <span class="arrow">
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.4375 13.2617C1.17383 13.2617 0.939453 13.1738 0.763672 12.998C0.382812 12.6465 0.382812 12.0312 0.763672 11.6797L5.71484 6.69922L0.763672 1.74805C0.382812 1.39648 0.382812 0.78125 0.763672 0.429688C1.11523 0.0488281 1.73047 0.0488281 2.08203 0.429688L7.70703 6.05469C8.08789 6.40625 8.08789 7.02148 7.70703 7.37305L2.08203 12.998C1.90625 13.1738 1.67188 13.2617 1.4375 13.2617Z" fill="currentColor"/>
            </svg>
          </span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'ExtraNavigation'
}
</script>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

li {
  display: block;
}

a {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 14px;
  font-family: brandon-grotesque, sans-serif;
  font-weight: 500;
  line-height: 1.1;
  min-height: 60px;
  padding: 10px;
  color: #FFF;
  border-bottom: 1px solid #FFF;
}

a:hover {
  background-color: #3b4348;
}

span {
  display: block;
}

.title {
  flex-grow: 1;
  padding-top: 2px;
}

.arrow {
  width: 20px;
  flex-shrink: 0;
  margin-left: 10px;
}

.arrow svg {
  display: block;
}

.icon {
  margin-right: 10px;
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

img {
  display: block;
}

nav {
  background-color: #5B676F;
}
</style>
